<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <div class="section">
          <div v-if="!isView">
            <el-button
              v-if="!isView && splitBillButton"
              :disabled="nowPage === 0"
              no="1"
              type="primary"
              @click="theLastPageHandler"
            >
              {{ $t('Invoice.invoice_theLastPage') }}
            </el-button>
            <el-button
              v-if="!isView && splitBillButton"
              :disabled="nowPage === splitCurrencyList.length - 1"
              no="2"
              type="primary"
              @click="theNextPageHandler"
            >
              {{ $t('Invoice.invoice_theNextPage') }}
            </el-button>
            <el-button type="primary" no="3" @click="cancelSave">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
            <el-button type="primary" :disabled="btnSaveEnable" no="4" @click="saveBilling">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <span v-if="!isView && splitBillButton" style="padding-right: 5px;padding-left: 5px">{{ nowPage + 1 + '/' + splitCurrencyList.length }}</span>
          </div>
          <div>
            <el-button v-if="isView" type="primary" no="5" @click="cancel">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
            <el-button v-if="isView && canEditBilling && !isAgentBilling && !isOcPaymentLock" type="primary" no="6" @click="editBilling">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button
              v-if="isView && billingUuid && $checkPermission(['button_ACTBilling_createInvoiceFromBilling']) && !isAgentBilling"
              type="primary"
              no="7"
              @click="makeInvoiceEvent"
            >{{ !billing.ar ? $t('CargoMsg.Cargo_CollectInvoice') : $t('CargoMsg.Cargo_Invoicing') }}
            </el-button>
            <el-button
              v-if="isView && billingUuid && $checkPermission(['button_ACTBilling_writeoffBilling']) && !isAgentBilling && isOcCanWriteOff"
              type="primary"
              no="8"
              @click="writeoffHandler"
            >{{ $t('Billing.billing_writeOff') }}
            </el-button>
            <el-button
              v-if="isView && billingUuid && !billing.ar && $checkPermission(['button_ACTBilling_payauthBillingGroup']) && !isAgentBilling"
              type="primary"
              no="9"
              @click="doBillPayment"
            >{{ $t('CargoMsg.Cargo_ApplyForPayment') }}
            </el-button>
            <el-button v-if="isView && !isAgentBilling" type="primary" no="10" @click="printEvent">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
            <el-button
              v-if="isView && billingUuid && this.$checkPermission(['button_ACTBilling_updateBillingInputDate']) && !isAgentBilling && !isOcPaymentLock"
              type="primary"
              no="11"
              @click="showBillDateModifyDialog=true"
            >{{ $t('CargoMsg.Cargo_AdjustBillDate') }}
            </el-button>
            <el-button
              v-if="isView && billingUuid && showSplitBillChargesBtn && canSplit && $checkPermission(['button_ACTBilling_splitBillCharges']) && !isAgentBilling && !isOcPaymentLock"
              type="primary"
              no="12"
              @click="splitBillChargesEvent"
            >{{ $t('CargoMsg.Cargo_SplitBillingFees') }}
            </el-button>
            <el-button v-if="toExoSystemOC && isView" no="showPushResultLog" type="primary" @click="pushResultLogDialog.visible = true">{{ $t('CargoMsg.Cargo_PushResultLog') }}</el-button>
          </div>
        </div>
        <div v-show="!expandedGrid" style="display:flex;">
          <!--账单基本信息-->
          <bill-form
            v-if="showBillForm"
            ref="billForm"
            no="14"
            style="width: 100%"
            :billing="billing"
            :billing-form-params="billingFormParams"
            :is-view="isView"
            :customer-detail="customerDetail"
            :create-bill-way="createBillWay"
            :accounts="accounts"
            @splitBill="splitBillChangeEvent"
            @calculateAmount="calculateAmount"
            @currencyChangeEvent="currencyChangeEvent"
          />
        </div>
        <div class="section" style="text-align: center">
          <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
        </div>
        <div v-show="!isView" class="section">
          <div style="flex:1">
            <el-button type="primary" no="15" @click="addBillChargeEvent">{{ $t('CargoMsg.Cargo_AddBillCharge') }}</el-button>
            <el-button type="primary" no="16" @click="removeBillChargeEvent">
              {{ reconciliationType === 'charge' ? $t('CargoMsg.Cargo_RemoveBillCharge') : $t('CargoMsg.Cargo_RemoveAll') }}
            </el-button>
            <el-button v-if="reconciliationType === 'job'" type="primary" no="17" @click="removePartBillChargeEvent">
              {{ $t('CargoMsg.Cargo_ViewDeleteChargeDetail') }}
            </el-button>
            <el-button v-if="billing.uuid && $checkPermission(['button_ACTBilling_addAdjustment'])" type="primary" no="18" @click="chargeJustEvent(0)">{{ $t('CargoMsg.Cargo_IncreaseAdjustment') }}</el-button>
            <el-button v-if="billing.uuid && $checkPermission(['button_ACTBilling_editAdjustment'])" type="primary" no="19" @click="chargeJustEvent(1)">{{ $t('CargoMsg.Cargo_EditAdjustment') }}</el-button>
            <el-button v-if="billing.uuid && $checkPermission(['button_ACTBilling_deleteAdjustment'])" type="primary" no="20" @click="chargeJustEvent(2)">{{ $t('CargoMsg.Cargo_DeleteAdjustment') }}</el-button>
            <el-button v-if="billing.uuid" type="primary" no="21" @click="treatmentDiffEvent">{{ $t('CargoMsg.Cargo_ProcessingDifference') }}</el-button>
            <el-button v-if="billing.uuid" type="primary" no="22" @click="batchUnConfirmBillingEvent">{{ $t('CargoMsg.Cargo_CancelConfirm') }}</el-button>
            <el-button v-if="billing.uuid" type="primary" no="23" @click="batchConfirmBillingEvent">{{ $t('CargoMsg.Cargo_BatchConfirm') }}</el-button>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :config-module="reconciliationType === 'job'?'190907':'190911'"
            :grid-options="gridOptions"
            :column-defs="dynamicColumnDefs"
            :grid-params.sync="gridParams"
            :row-data="rowData"
            @gridReady="params=>{gridApi=params.api}"
          />
          <div class="app-main-inner-row" style="display: flex;justify-content: flex-end">
            <span v-show="dataShow && totalAmountToCurrency.labelText" v-text="totalAmountToCurrency.labelText" />
            <span v-show="dataShow && totalAmountToCurrency.selectionCountLabel" v-text="totalAmountToCurrency.selectionCountLabel" />
            <charge-currency-total-group
              :key="1"
              amount-to-currency=""
              mode="group"
              type="revenueAbs"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              ar-field="chargeReceivable"
            />
            <span v-show="dataShow && rowData && rowData.length > 0">{{ $t('CargoMsg.Cargo_ReconciliationAmount') }}</span>
            <charge-currency-total-group
              :key="2"
              amount-to-currency=""
              mode="group"
              type="revenueAbs"
              :data-provider="totalAmountToCurrency.dataProvider"
              data-field="chargeBillingAmount"
              :currency-field="totalAmountToCurrency.currencyField"
              ar-field="chargeReceivable"
            />
          </div>
        </div>
      </div>
      <!--调整账单日期-->
      <el-dialog
        v-el-drag-dialog
        custom-class=""
        :close-on-click-modal="false"
        :visible.sync="showBillDateModifyDialog"
        :title="$t('CargoMsg.Cargo_AdjustBillDate')"
        width="500px"
      >
        <div class="app-main-inner-row" style="padding-bottom: 10px;">
          <div class="filters">
            <el-form :inline="true" label-width="90px" label-position="left" @submit.native.prevent>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('CargoMsg.Cargo_BillDate')">
                  <el-date-picker
                    v-model="billingDate"
                    no="24"
                    type="date"
                    style="width:251px;"
                    clearable
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div slot="footer">
          <el-button type="primary" no="25" size="mini" @click="updateBillingDateEvent">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button size="mini" no="26" @click="showBillDateModifyDialog=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </el-dialog>
      <!--销账-->
      <write-off-dialog v-if="writeOffDialog.visible" ref="dgWriteoff" :location="location" :visible.sync="writeOffDialog.visible" :title="title" :properties="properties" />
      <!--加入费用-->
      <join-charge-dialog
        v-if="showJoinChargeDialog"
        :visible.sync="showJoinChargeDialog"
        :search-item-module="searchItemModule"
        :default-conditions="addChargeCondition"
        @addChargeCallBackEvent="addChargeCallBackEvent"
        @toSearchTemplate="toSearchTemplate"
      />
      <!--按业务进行费用调整-->
      <job-charge-adjustment-dialog
        v-if="showJobChargeAdjustmentDialog"
        :visible.sync="showJobChargeAdjustmentDialog"
        :default-properties="defaultProperties"
        @jobChargeAdjustmentCallBackEvent="chargeJustCallBackEvent"
      />
      <!--按费用进行费用调整 -->
      <charge-adjustment-dialog
        v-if="showChargeAdjustmentDialog"
        :visible.sync="showChargeAdjustmentDialog"
        :default-properties="defaultProperties"
        @chargeAdjustmentCallBackEvent="chargeJustCallBackEvent"
      />
      <!--移除/查看明细-->
      <remove-part-bill-charge-dialog
        v-if="showRemovePartBillChargeDialog"
        :visible.sync="showRemovePartBillChargeDialog"
        :part-charges="partCharges"
        @removePartBillChargeCallBackEvent="removePartBillChargeCallBackEvent"
      />
      <!--冲突费用明细弹出框-->
      <conflict-charges-dialog
        v-if="showConflictChargeDialog"
        :visible.sync="showConflictChargeDialog"
        :charges="conflictCharges"
        view-source="billingDetail"
        @conflictChargeCallBackEvent="conflictChargeCallBackEvent"
      />
      <!--按业务-费用拆分-->
      <charge-split-by-job-dialog
        v-if="showChargeSplitByJobDialog"
        :visible.sync="showChargeSplitByJobDialog"
        :except-keys="exceptKeys"
        view-source="billingDetail"
        @chargeSplitByJobCallBackEvent="chargeSplitByJobCallBackEvent"
      />
      <!--按费用-费用拆分-->
      <charge-split-by-charge-dialog
        v-if="showChargeSplitByChargeDialog"
        :visible.sync="showChargeSplitByChargeDialog"
        :old-charge="spiltCharge"
        :location="location"
        view-source="billingDetail"
        @chargeSplitByChargeCallBackEvent="chargeSplitByChargeCallBackEvent"
      />
      <!--开票-->
      <make-invoice-dialog ref="invoice" :location="location" />

      <!--打印-->
      <cargo-template-selector-dialog
        ref="cargoTemplateSelectorDialog"
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        :pre-print-callback="prePrintCallback"
      />
      <!--申请付款-->
      <bill-payment-dialog
        ref="billPayment"
        :visible.sync="showBillPaymentDialog"
        :create-submit="true"
        :location="location"
        step="step2"
        mode="overview"
        @cancel="cancelBillPayment"
      />
      <!-- 数据推送结果记录 -->
      <push-result-log-dialog v-if="pushResultLogDialog.visible" :visible.sync="pushResultLogDialog.visible" :job-uuid="billing.uuid || ''" log-source="billing" />
      <!-- 多条业务 配置规则验证弹窗 -->
      <batch-checking-window
        v-if="batchCheckingWindow.visible"
        :visible.sync="batchCheckingWindow.visible"
        :lob="batchCheckingWindow.lob"
        :jobs="batchCheckingWindow.jobs"
        :check-node="batchCheckingWindow.checkNode"
        :call-back="batchCheckingWindow.callBack"
        :call-back2="batchCheckingWindow.callBack2"
      />
      <!-- 账单保存校验弹窗 -->
      <checking-save-job-window
        v-if="checkingSaveJobWindow.visible"
        :visible.sync="checkingSaveJobWindow.visible"
        :lob="checkingSaveJobWindow.lob"
        :row-data="checkingSaveJobWindow.rowData"
        :check-node="checkingSaveJobWindow.checkNode"
        :call-back="checkingSaveJobWindow.callBack"
      />
    </div>
  </div>
</template>

<script>

import writeOffDialog from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { batchCheckPartyBillingNoExist, updateBillingDate } from '@/api/clearing/billingNative'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { getGridSelected } from '@/utils/agGrid'
import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import chargeAdjustmentDialog from '@/components/Cargo/Act/chargeAdjustmentDialog'
import jobChargeAdjustmentDialog from '@/views/cargo/v0/Clearing/components/BillingNative/jobChargeAdjustmentDialog'
import removePartBillChargeDialog from '@/views/cargo/v0/Clearing/components/BillingNative/removePartBillChargeDialog'
import conflictChargesDialog from '@/views/cargo/v0/Clearing/components/BillingNative/conflictChargesDialog'
import chargeSplitByJobDialog from '@/views/cargo/v0/Clearing/components/BillingNative/chargeSplitByJobDialog'
import chargeSplitByChargeDialog from '@/views/cargo/v0/Clearing/components/BillingNative/chargeSplitByChargeDialog'
import makeInvoiceDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/makeInvoiceDialog'
import BillForm from '@/components/Cargo/Act/splitBillForm'
import BillDetailHp from '@/components/Cargo/Act/splitBillDetailHp'
import * as NumberUtils from '@/utils/NumberUtils'
import DateUtils from '@/utils/dateUtils'
import lodash from 'lodash'
import { Assert } from '@/utils/validate'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { Once } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { checkPartyBillingNoExist, setBillingsNo } from '@/api/clearing/billingNative'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { getNotWriteoffCharges } from '@/api/clearing/actualAmount'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import StrUtils from '@/utils/StrUtils'
import moment from 'moment'
import { DocumentManage } from '@/utils/commonUtil'
import { Billing } from '@/class/model/act/Billing'
import pushResultLogDialog from '@/components/Cargo/Job/pushResultLogDialog'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getBankAccountList } from '@/api/bankAccount'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow.vue'
import { checkChargeByBillingSaveNode } from '@/api/booking/job'

export default {
  name: 'SplitBillDetail',
  components: {
    checkingSaveJobWindow,
    BatchCheckingWindow,
    CargoAdvanceSelect,
    writeOffDialog, // 销账弹出框
    joinChargeDialog, // 加入费用弹窗
    chargeAdjustmentDialog, // 按费用-费用调整弹出框
    jobChargeAdjustmentDialog, // 按业务-费用调整弹出框
    removePartBillChargeDialog, // 按业务-移除/查看全部弹出框
    conflictChargesDialog, // 冲突费用明细弹出框
    chargeSplitByJobDialog, // 按业务进行费用拆分
    chargeSplitByChargeDialog, // 按费用进行费用拆分
    makeInvoiceDialog, // 开票弹出框
    BillForm, // 账单基本信息
    ChargeCurrencyTotalGroup, // 合计
    cargoTemplateSelectorDialog, // 打印
    billPaymentDialog,
    pushResultLogDialog
  },
  props: {
    viewSource: { type: String, required: true }, // 来自账单-bill/还是对账-reconciliation
    reconciliationType: { type: String, required: true },
    billingUuid: { type: String, required: true },
    viewBilling: { type: Boolean },
    newBilling: { type: Object, required: true },
    newCharges: { type: Array, required: true },
    customerDetail: { type: Object, required: true },
    createBillWay: { type: Number, default: 0 }, // 创建账单方式【0：结算对象 1、结算代理】
    accounts: { type: Array, default: () => [] }, // 结算对象
    location: { type: String, required: false }
  },
  data() {
    return {
      dataShow: true, // 底部计算组件文字是否显示
      documentManage: new DocumentManage(),
      requestSource: this.viewSource, // 请求来源
      loading: null,
      value: '',
      selectTypeNames: TYPE_NAMES,
      activeTabName: 'bill',
      showWriteOffDialog: false,
      showBillDateModifyDialog: false,
      showJoinChargeDialog: false,
      searchItemModule: '5042',
      showChargeAdjustmentDialog: false,
      showJobChargeAdjustmentDialog: false,
      showRemovePartBillChargeDialog: false,
      showConflictChargeDialog: false,
      showChargeSplitByJobDialog: false,
      showChargeSplitByChargeDialog: false,
      expandedGrid: false,
      gridOptions: {},
      gridParams: {},
      gridApi: null,
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      isView: this.viewBilling,
      billing: new Billing().fillDefaultValue().getData(),
      addChargeCondition: { // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        accountId: 0
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      checkingSaveJobWindow: {
        visible: false,
        rowData: [],
        lob: '',
        checkNode: 0,
        callBack: null
      },
      defaultProperties: {}, // 费用调整默认条件
      partCharges: [], // 移除/查看明细条件
      conflictCharges: [], // 账单保存时有冲突的费用集合
      billingDate: new Date(), // 账单日期调整临时变量，初始化为当前日期
      canSplit: false, // 费用拆分模式
      showSplitBillChargesBtn: false, // 是否显示费用按钮
      exceptKeys: [], // 按业务进行费用拆分专用
      spiltCharge: {}, // 按费用进行拆分专用
      diffChargeByBillingAmountPattern: 0, // 对账金额大于费用金额处理模式
      makeInvoiceProperties: { // 开票动作传递的参数
        keys: [], // 此处统一传递uuid集合，后续会请求后台，组装树状结构
        isAr: false,
        step: '',
        hedgeKeys: [], // 对冲开票uuid集合
        isHedge: false,
        isSkipInvoiceFrom: false,
        makeInvoiceMethod: 3 // 开票方式:3代表账单
      },
      billDetailHp: new BillDetailHp(this),
      billingFormParams: {
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑
        isShowCounterPartyBillingNo: false, // 是否展示代理账单号
        newInvoiceTypesOfBilling: false // 是否国内账单发票类型客户化(成基)
      },
      showBillForm: true,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 5000,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      totalAmountToCurrency: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        dataProvider: [], // 数据源
        dataField: 'chargeAmount',
        currencyField: 'chargeCurrency',
        type: 'auto'
      },
      once: new Once(this),
      prePrintCallback: null,
      templateSelectorDialog: { // 模板选择弹窗
        visible: false,
        cxt: null,
        category: 'BILLING',
        data: {
          BILLING_UUID: []
        }
      },
      showBillPaymentDialog: false,
      properties: {
        isExt: false, // ext
        entities: [], // 销账实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        isAr: false, // 是否应收
        isHedge: false, // 是否对冲
        isEntitiesAr: false, // 是否应收
        isHedgeEntitiesAr: false, // 是否应收
        rpDate: moment().format('yyyy-MM-DD'), // 收付日期
        isOversea: false, // 是否海外销账
        defaultCurrency: 'RMB', // 默认币种
        accountId: 0, // 结算单位
        chargeAccountIds: [], // 按费用销账结算单位
        hedgeChargeAccountIds: [],
        writeoffByDifferentAccount: false, // WriteoffByDifferentAccount, 不同结算单位合并销账
        writeoffCheckBillpaymentDone: false, // WriteoffCheckBillpaymentDone, 销账号确认付款流程已经走完
        mustUseActualAmountWriteoff: false, // MustUseActualAmountWriteoff, 是否必须使用实收付销账
        isHQWriteoffConfirm: false, // isHQWriteoffConfirm, 是否需要通过总部核销(UBI)
        isWriteoffCurrencyByInvoice: false, // isWriteoffCurrencyByInvoice, 销账默认按费用币种，缺省值0；可选项1（按发票销账时，默认取发票币种）
        payAfterPayApply: 0, // PayAfterPayApply, 需申请后才能付款
        allowWriteOffDiffBranch: false, // 正操作的数据所在分公司不属于当前分公司或上一级分公司的情况是否允许销账
        actualAmount: {}, // 实收实付
        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        selectedEntitiesOrigin: [], // 已经选中的实体(原记录)
        writeOffMode: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        writeOffModeHedge: 1, // 销账模式: 1=费用、2=发票、3=账单、4=对账单、5=付款申请
        currencys: [], // 费用所包含的币种
        otherCurrencyRate: [] // 其它币种和汇率
      },
      writeOffDialog: { visible: false },
      btnSaveEnable: false, // 是否可以点击保存
      isSaveBillRate: false, // 是否使用账单汇率进行计算
      toExoSystemOC: false, // 是否橙联推送
      hmToFinanceApi: false,
      pushResultLogDialog: {
        visible: false
      },
      initialBilling: null,
      splitBillData: {}, // 拆分的账单
      splitCurrencyList: [], // 拆分的币种
      splitBillButton: false,
      ourBankAccountArray: null,
      nowPage: 0 // 当前页
    }
  },
  computed: {
    url() {
      return URL
    },
    dynamicColumnDefs() {
      let columnDefs = []
      if (this.reconciliationType === 'job') {
        columnDefs = [
          {
            headerName: '', checkboxSelection: true, width: 55,
            sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_customer'), field: 'jobCustomerId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingCharge_mblNo'), field: 'jobMbl', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobImportHbl', initialWidth: 200 },
          { headerName: this.$t('Invoice.invoice_containerNo'),
            field: 'containerContainerNo',
            cellRenderer: (params) => {
              while (true) {
                if (params.value.indexOf(',') === 0) {
                  params.value = params.value.substring(1, params.value.length)
                } else if (params.value.substring(params.value.length - 1, params.value.length) == ',') {
                  params.value = params.value.substring(0, params.value.length - 1)
                } else {
                  break
                }
              }
              return params.value
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('Billing.billingCharge_carrier'), field: 'jobCarrierId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'), field: 'jobVesselFlight', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_portOfDischarge'), field: 'jobDischargingPortCode', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          { headerName: 'SoNo', field: 'jobSoNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_dateOfDeparture'), field: 'jobEtd', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_bookingAgent'), field: 'jobBookingAgent', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_operation'), field: 'jobOp', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_sales'), field: 'jobSales', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_businessType'), field: 'jobLob', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Billing.billingCharge_currency'), field: 'jobChargeCurrency', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'jobAr', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_chargesTotalAmount'), field: 'jobChargeAmountTotal', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_reconciliationAmount'), field: 'jobBillingAmount', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'cargo-cell-input',
              attrs: {
                isEditCBFunc: (params) => { return this.isRowEdit(params) && !this.isView && this.billingUuid },
                complexTextConverter: (data, val) => {
                  return !val ? '0.00' : ColumnUtils.numberColumnLabelFunc(NumberUtils.roundHalfUp(val), 2)
                }
              },
              valueChanged: p => { this.onCellChange(p) }
            }
          },
          {
            headerName: this.$t('Billing.billingJob_difference'), field: 'jobDifferenceAmount', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'span',
              attrs: { textConverter: (val) => { return !val ? '0.00' : ColumnUtils.numberColumnLabelFunc(NumberUtils.roundHalfUp(val), 2) } }
            }
          },
          {
            headerName: this.$t('Billing.billingJob_confirmState'), field: 'jobConfirmState', initialWidth: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isView && this.billing && this.billing.uuid,
              tag: !this.isView && this.billing && this.billing.uuid ? 'el-checkbox' : 'span',
              attrs: {
                isEditCBFunc: (params) => {
                  return (this.isRowEdit(params) || this.checkConfirmable(params)) && this.billingUuid
                }, trueLabel: 1, falseLabel: 0, textConverter: (val) => {
                  return val ? this.$t('CargoMsg.Cargo_Confirmed') : this.$t('CargoMsg.Cargo_Unconfirmed')
                }
              },
              valueChanged: p => {
                this.onCellChange(p)
              }
            }
          }
        ]
      } else if (this.reconciliationType === 'charge') {
        columnDefs = [
          {
            headerName: '', checkboxSelection: true, initialWidth: 55,
            sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', initialWidth: 200 },
          { headerName: 'SoNo', field: 'jobSoNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingCharge_mblNo'), field: 'jobMbl', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobImportHbl', initialWidth: 200 },
          { headerName: this.$t('Invoice.invoice_containerNo'), field: 'jobContainerNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'), field: 'jobVesselFlight', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeChargeItemId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_paymentType'), field: 'chargeReceivable', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingForm_collectAndPrepaidOrNot'), field: 'chargeAdvance', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Billing.billingCharge_currency'), field: 'chargeCurrency', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingForm_unit'), field: 'chargeMeasure', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_amount'), field: 'chargeQuantity', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_unitPrice'), field: 'chargeUnitRate', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxIncludedPrice'), field: 'chargeAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxExcludedPrice'),
            field: 'chargeExcludingTaxAmount',
            initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_taxRate'), field: 'chargeTaxRate', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_taxAmount'), field: 'chargeTaxAmount', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_reconciliationAmount'), field: 'chargeBillingAmount', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'cargo-cell-input',
              attrs: {
                isEditCBFunc: (params) => { return this.isRowEdit(params) && !this.isView && this.billingUuid },
                complexTextConverter: (data, val) => {
                  return !val ? '0.00' : ColumnUtils.numberColumnLabelFunc(NumberUtils.roundHalfUp(val), 2)
                }
              },
              valueChanged: p => { this.onCellChange(p) }
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_difference'), field: 'chargeDiffAmount', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'span',
              attrs: { textConverter: (val) => { return !val ? '0.00' : ColumnUtils.numberColumnLabelFunc(NumberUtils.roundHalfUp(val), 2) } }
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_confirmState'), field: 'chargeConfirmState', initialWidth: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isView && this.billing && this.billing.uuid,
              tag: !this.isView && this.billing && this.billing.uuid ? 'el-checkbox' : 'span',
              // 校验当前行 可以编辑 并且 可确认，才允许 操作 勾选框
              attrs: {
                trueLabel: 1,
                falseLabel: 0,
                isEditCBFunc: (params) => {
                  return (this.isRowEdit(params) || this.checkConfirmable(params)) && this.billingUuid
                },
                textConverter: (val) => {
                  return val ? this.$t('CargoMsg.Cargo_Confirmed') : this.$t('CargoMsg.Cargo_Unconfirmed')
                }
              },
              valueChanged: p => {
                this.onCellChange(p)
              }
            },
            filterParams: {
              valueFormatter: (params) => {
                if (params.value == '1') {
                  return this.$t('Clearing.Confirmed')
                } else {
                  return this.$t('Clearing.Unconfirmed')
                }
              }
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_confirmationRemarks'), field: 'chargeConfirmRemarks', initialWidth: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'cargo-cell-input',
              attrs: {
                isEditCBFunc: (params) => { return this.isRowEdit(params) && this.billingUuid },
                complexTextConverter: (data, val) => {
                  return val
                }
              },
              valueChanged: p => { this.onCellChange(p) }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'chargeChanger',
            field: 'chargeChanger',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_remarks'),
            colId: 'chargeRemarks',
            field: 'chargeRemarks',
            initialWidth: 180
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            field: 'chargeInvoiceTitle',
            hide: true,
            width: 100
          }, {
            headerName: this.$t('FinanceManage.international_settlementAgent'),
            field: 'chargeSettlementAgentId',
            width: 150,
            hide: true,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
            }
          }
        ]
      }
      // 公共列
      columnDefs.push(
        { headerName: this.$t('SeaExport.CustomJobType'), field: 'jobCustomJobType', initialWidth: 150, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customJobTypeLabelFunc(params.value)
          } }
      )
      return columnDefs
    },
    total() {
      return this.rowData.length || 0
    },
    // 标题
    title() {
      let title = this.properties.isOversea ? this.$t('CargoMsg.Cargo_OverseasWriteOff') : (this.properties.isHedge ? this.$t('WriteOff.hedgingWriteOffs') : this.$t('WriteOff.writeOffs'))
      if (this.properties.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.properties.accountId))
        if (company) {
          if (this.$t('WriteOff.writeOffs') === title) {
            if (!this.properties.writeoffByDifferentAccount) {
              const isChinese = this.$store.getters.language === 'zh'
              title += ' - ' + (isChinese ? company.chineseName : company.englishName)
            }
          } else {
            const isChinese = this.$store.getters.language === 'zh'
            title += ' - ' + (isChinese ? company.chineseName : company.englishName)
          }
        }
      }
      return title
    },
    // 是否可以编辑账单
    canEditBilling() {
      return this.$checkPermission(['button_ACTBilling_editBilling'])
    },
    // 是否代理分成账单
    isAgentBilling() {
      return this.billing && this.billing.billingType === BillingConstants.BILLING_TYPE_AGENT.code
    },
    // 是否付款锁定
    isOcPaymentLock() {
      if (this.billing && this.billing.ocPaymentLock !== undefined) return this.billing.ocPaymentLock
      return false
    },
    // 能否核销
    isOcCanWriteOff() {
      if (this.billing && !this.billing.ar) return true
      if (this.billing && this.billing.prePayment) return this.billing.prePayment
      if (this.billing && this.billing.ocCanWriteOff !== undefined) return this.billing.ocCanWriteOff
      return true
    }
  },
  created() {
    this.btnSaveEnable = false
    const currentThis = this
    this.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      suppressColumnVirtualisation: true,
      context: {
        componentParent: this
      },
      defaultColDef: {
        resizable: true,
        filter: true
      },
      pagination: false,
      getRowStyle: function(params) {
        const data = params.data
        if (data) {
          if (data.entity === 'charge') {
            if (data.hasOwnProperty('chargeVerifiedAmount')) {
              return (data.chargeConfirmState > 0 || data.chargeVerifiedAmount !== 0) ? { background: '#EFEFEF' } : { background: 'white' }
            } else {
              return data.chargeConfirmState > 0 ? { background: '#EFEFEF' } : { background: 'white' }
            }
          } else {
            return data.jobConfirmState > 0 ? { background: '#EFEFEF' } : { background: 'white' }
          }
        }
      },
      onSelectionChanged() {
        currentThis.once.excute(currentThis.selectionChange, [], 200)
      }
    }
  },
  async beforeMount() {
    await cache.load(cacheName.CONFIG)
    this.canSplit = Number(cache.config.get('SplitBillChargesAllowed')) === 1
    this.diffChargeByBillingAmountPattern = Number(cache.config.get('DiffChargeByBillingAmountPattern'))
    this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
    this.billingFormParams.newInvoiceTypesOfBilling = Number(cache.config.get('newInvoiceTypesOfBilling')) === 1
    this.toExoSystemOC = Number(cache.config.get('ToExoSystem')) === 2
    this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
    this.showSplitBillChargesBtn = this.viewBilling
    this.btnSaveEnable = this.viewBilling
    this.splitBillButton = false
    if (this.customerDetail && this.customerDetail.currencyRequirements === 3) {
      this.splitBillButton = true
    }
    this.ourBankAccountArray = null
    if (this.requestSource === 'bill') { // 从账单页签进入账单详情
      const requires = this.hmToFinanceApi ? ['hmToFinanceApi'] : []
      this.billDetailHp.queryBillingDetail({ requires })
    } else { // 对账页签进入详情
      await this.queryOurBankAccountList()
      await this.onShow()
    }
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  },
  methods: {
    cancel() {
      this.$emit('cancel', { action: 'cancel', data: this.billing })
    },
    async queryOurBankAccountList() {
      if (!this.ourBankAccountArray) {
        await getBankAccountList(this.$store.getters.currentOfficeUuid).then((res) => {
          if (res.data && res.data.length > 0) {
            this.ourBankAccountArray = res.data
          }
        })
      }
    },
    onShow() {
      this.billing = { ...this.newBilling }
      this.showBillForm = true
      const requires = this.hmToFinanceApi ? ['hmToFinanceApi'] : []
      if (this.reconciliationType === 'job') {
        this.billDetailHp.queryJobOfBilling({ requires })
      } else if (this.reconciliationType === 'charge') {
        this.billDetailHp.queryChargeOfBilling({ requires })
      }
    },
    async saveBilling() {
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
        if (checkNodeFlag) {
          // 执行校验并处理校验结果
          const result = await this.performBillingValidation()
          if (result && result.needShowDialog) {
            this.showBillingValidationDialog(result.data)
          } else {
            await this.saveBillingDetail()
          }
        } else {
          await this.saveBillingDetail()
        }
      } else {
        await this.saveBillingDetail()
      }
    },
    // 执行账单校验
    async performBillingValidation() {
      // 调用实际的校验接口
      const requestData = {
        checkNode: CheckRuleConstants.NODE_SAVE_BILLING.code,
        chargeUuidList: this.rowData ? this.rowData.map(item => item.uuid) : [],
        branchId: this.$store.getters.currentOfficeId,
        billing: this.billing || {}
      }

      const loading = getLoading()
      const response = await checkChargeByBillingSaveNode(requestData).finally(
        () => loading.close()
      )
      if (response && response.data) {
        // 检查是否有校验失败的项
        const hasValidationErrors = this.checkValidationResult(response.data)

        return {
          needShowDialog: hasValidationErrors,
          data: response.data
        }
      }
    },

    // 检查校验结果是否有错误
    checkValidationResult(validationData) {
      if (!validationData) return false

      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          for (const rule of rules) {
            if (!rule.match && !rule.continueCheck) {
              return true // 有不匹配且不能继续的规则
            }
            if (!rule.match && rule.checkMode === 1) {
              return true // 有不匹配的错误级别规则
            }
          }
        }
      }
      return false
    },

    // 显示账单校验弹窗
    showBillingValidationDialog(validationData) {
      // 转换校验数据为CheckingSaveJobWindow组件需要的格式
      const convertedData = this.convertValidationDataForCheckingSaveJobWindow(validationData)

      this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
      this.checkingSaveJobWindow.rowData = convertedData
      this.checkingSaveJobWindow.callBack = this.saveBillingDetail
      this.checkingSaveJobWindow.visible = true
      this.checkingSaveJobWindow.lob = 'SE'
    },

    // 转换校验数据格式以适配CheckingSaveJobWindow组件
    convertValidationDataForCheckingSaveJobWindow(validationData) {
      const result = []
      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          // 直接使用校验规则数据，CheckingSaveJobWindow会处理展示
          result.push(...rules)
        }
      }
      return result
    },
    // 保存账单
    async saveBillingDetail() {
      if (this.splitBillButton) {
        await this.doSaveSplitBillingDetail()
      } else {
        await this.doSaveBillingDetail()
      }
    },
    async doSaveSplitBillingDetail() {
      const splitBillData = { ...this.splitBillData }
      const counterPartyBillingNoList = []
      let tips = false
      let tipMessage = ''
      // 校验对方账单号是否存在
      for (const key of Object.keys(splitBillData)) {
        const bill = splitBillData[key]
        if (bill.counterPartyBillingNo) {
          if (counterPartyBillingNoList.includes(bill.counterPartyBillingNo)) {
            // 拆分账单中存在对方账单号重复
            tips = true
          } else {
            counterPartyBillingNoList.push(bill.counterPartyBillingNo)
          }
        }
        const message = await this.billDetailHp.checkAgentAndTitle()
        if (message) {
          tipMessage += '【' + key + '】账单:' + message + '\n'
        }
      }
      // 校验商务报价金额
      const businessMsg = await this.billDetailHp.checkCanSave()
      if (!StrUtils.isEmpty(businessMsg)) {
        this.$message.warning(businessMsg)
        return
      }
      let resData = 0
      if (!tips && counterPartyBillingNoList.length > 0) {
        // 后端接口检查 拆分账单中是否存在对方账单号重复
        const res = await batchCheckPartyBillingNoExist(counterPartyBillingNoList, {
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType
        })
        resData = res.data
      }
      // 拆分账单中存在重复 或后端检查出重复
      if (tips || resData > 0) {
        const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      let isSave = true
      if (!StrUtils.isEmpty(tipMessage)) {
        isSave = false
        await this.$confirm(tipMessage, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {})
      }
      if (isSave) {
        this.btnSaveEnable = true
        this.billDetailHp.saveSplitBilling()
      }
    },
    async doSaveBillingDetail() {
      if (this.billing.counterPartyBillingNo) {
        const res = await checkPartyBillingNoExist({
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType,
          counterPartyBillingNo: this.billing.counterPartyBillingNo
        })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }
      // 校验商务报价金额
      const businessMsg = await this.billDetailHp.checkCanSave()
      if (!StrUtils.isEmpty(businessMsg)) {
        this.$message.warning(businessMsg)
        return
      }
      const message = await this.billDetailHp.checkAgentAndTitle()
      let isSave = true
      if (!StrUtils.isEmpty(message)) {
        isSave = false
        await this.$confirm(message, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {})
      }
      if (isSave) {
        this.btnSaveEnable = true
        this.billDetailHp.saveBillingDetail()
      }
    },
    // 取消保存账单
    cancelSave() {
      if (this.requestSource === 'reconciliation') {
        this.$emit('backReconciliation')
      } else {
        this.$confirm(this.$t('CargoMsg.Cargo_ModifiedDataNotSavedCancel'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.isView = true
          this.btnSaveEnable = false
          this.billDetailHp.queryBillingDetail()
        }).catch(() => {
          // return Promise.reject('已取消确认')
        })
      }
    },
    // 编辑账单
    editBilling() {
      if (!BillingUtils.editable(this.billing)) {
        return
      }
      this.isView = false
      this.btnSaveEnable = false
      this.billDetailHp.checkBillingRateEditable()
    },
    // 增加调整0/修改调整1/删除调整2
    chargeJustEvent(operateType) {
      const chooseRows = getGridSelected(this.gridOptions)
      const defaultProperties = this.defaultProperties
      if (this.reconciliationType === 'charge') { // 按费用
        const charge = chooseRows[0]
        if (chooseRows.length !== 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
          return
        }
        if (operateType === 0) {
          if (!BillingNativeUtils.checkJustChargeJob(charge)) return
          defaultProperties['operateType'] = BillingNativeUtils.ADD_JUST
        } else if (operateType === 1) {
          if (!BillingNativeUtils.checkJustCharge(charge)) return
          defaultProperties['operateType'] = BillingNativeUtils.EDIT_JUST
        } else {
          if (!BillingNativeUtils.checkJustCharge(charge)) return
          defaultProperties['operateType'] = BillingNativeUtils.DEL_JUST
        }
        defaultProperties['isEditing'] = !this.isView
        defaultProperties['modifyCharge'] = lodash.cloneDeep(charge)
        this.showChargeAdjustmentDialog = true
      } else { // 按业务
        if (chooseRows.length !== 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
          return
        }
        const job = chooseRows[0]
        if (operateType === 0) {
          defaultProperties['operateType'] = BillingNativeUtils.ADD_JUST
          if (!BillingNativeUtils.checkJustChargeJob(job)) return
        } else if (operateType === 1) {
          defaultProperties['operateType'] = BillingNativeUtils.EDIT_JUST
        } else {
          defaultProperties['operateType'] = BillingNativeUtils.DEL_JUST
        }
        defaultProperties['isEditing'] = !this.isView
        defaultProperties['charges'] = job['charges']
        this.showJobChargeAdjustmentDialog = true
      }
    },
    // 增加调整/修改调整/删除调整回调函数
    async chargeJustCallBackEvent(result) {
      if (result && result.length > 0) {
        const rowData = this.rowData
        for (let i = 0; i < result.length; i++) {
          const item = result[i]
          const mode = Number(item['mode'])
          const charge = item['charge']
          if (mode < 3) {
            if (this.reconciliationType === 'charge') {
              rowData.push(charge)
            } else {
              this.rowData = lodash.cloneDeep(BillingNativeUtils.appendJobCharges(charge, rowData))
            }
          } else {
            for (let i = 0; i < rowData.length; i++) {
              const rowItem = rowData[i]
              if (this.reconciliationType === 'charge') { // 按费用
                if (rowItem['uuid'] && charge['uuid'] && rowItem['uuid'] === charge['uuid']) { // 针对已经存在的费用进行更新
                  rowData[i] = charge
                  break
                } else if (!rowItem['uuid'] && !charge['uuid'] && rowItem.hasOwnProperty('chargeUid') && charge.hasOwnProperty('chargeUid') &&
                  rowItem['chargeUid'] && charge['chargeUid'] && rowItem['chargeUid'] === charge['chargeUid']) { // 针对新增的费用（此时费用还未入库）进行修改调整
                  rowData[i] = charge
                  break
                }
              } else { // 按业务
                const charges = rowItem['charges']
                if (charges && charges.length > 0) {
                  for (let i = 0; i < charges.length; i++) {
                    const oldCharge = charges[i]
                    if (oldCharge['uuid'] && charge['uuid'] && oldCharge['uuid'] === charge['uuid']) { // 针对已经存在的费用进行更新
                      charges[i] = charge
                      break
                    } else if (!oldCharge['uuid'] && !charge['uuid'] && oldCharge.hasOwnProperty('chargeUid') && charge.hasOwnProperty('chargeUid') &&
                      oldCharge['chargeUid'] && charge['chargeUid'] && oldCharge['chargeUid'] === charge['chargeUid']) { // 针对新增的费用（此时费用还未入库）进行修改调整
                      charges[i] = charge
                      break
                    }
                  }
                }
              }
            }
          }
        }
        this.rowData = lodash.cloneDeep(rowData)
        if (this.reconciliationType === 'charge') {
          this.showChargeAdjustmentDialog = false
        } else {
          this.showChargeAdjustmentDialog = false
          this.showJobChargeAdjustmentDialog = false
        }
        this.billDetailHp.recalculateBilling()
        await this.billDetailHp.refreshBilling()
      }
    },
    // 处理差额
    async treatmentDiffEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      let isCall = false
      let diffCharges = []
      await cache.load(cacheName.CONFIG)
      const diffChargePattern = Number(cache.config.get('DiffChargePattern'))

      if (this.reconciliationType === 'charge') { // 按费用差额处理
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseNotSelected'))
          return
        }
        if (diffChargePattern === 1) { // 差额处理
          diffCharges = await BillingNativeUtils.processChargeDiffAmount(chooseRows, function() {
            isCall = true
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_CanNotProcessUnsavedNewExpense'), 'warning')
          })
        } else { // 拆分
          diffCharges = await BillingNativeUtils.splitCharges(chooseRows, function() {
            isCall = true
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_UnsavedNewExpenseCanTBeSplit'), 'warning')
          })
          if (this.hmToFinanceApi && !isCall && diffCharges.length > 0) {
            for (const diffCharge of diffCharges) {
              const row = chooseRows.find(p => p.uuid === diffCharge.chargeDiffChargeUuid)
              if (row && row.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
                this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
                return
              }
            }
          }
        }
        if (isCall) {
          return
        } else {
          if (diffCharges.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseDifferentialsToProcess'))
            return
          }
        }
        if (diffCharges.length > 0) {
          const newRowData = this.rowData.concat(diffCharges)
          this.rowData = newRowData
          this.billDetailHp.recalculateBilling()
        }
      } else { // 按业务差额处理
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotSelected'))
          return
        }
        if (diffChargePattern === 1) { // 差额处理
          diffCharges = await BillingNativeUtils.processJobDiffAmount(chooseRows, function() {
            isCall = true
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_CanNotProcessUnsavedNewExpense'), 'warning')
          })
        } else { // 拆分
          diffCharges = await BillingNativeUtils.splitJobCharges(chooseRows, function() {
            Assert.isTrue(false, this.$t('CargoMsg.Cargo_UnsavedNewExpenseCanTBeSplit'), 'warning')
            isCall = true
          })
          if (this.hmToFinanceApi && !isCall && diffCharges.length > 0) {
            const jobCharges = []
            for (const row of chooseRows) {
              if (row.charges && row.charges.length > 0) {
                jobCharges.push(...row.charges)
              }
            }
            for (const diffCharge of diffCharges) {
              const charge = jobCharges.find(p => p.uuid === diffCharge.chargeDiffChargeUuid)
              if (charge && charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
                this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
                return
              }
            }
          }
        }
        if (isCall) {
          return
        } else {
          if (diffCharges.length === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_NoExpenseDifferentialsToProcess'))
            return
          }
        }
        for (let i = 0; i < diffCharges.length; i++) {
          this.rowData = lodash.cloneDeep(BillingNativeUtils.appendJobCharges(diffCharges[i], this.rowData))
        }
        this.billDetailHp.recalculateBilling()
      }
    },
    // 取消确认
    batchUnConfirmBillingEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectedUnConfirmedCharge'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelConfirmation'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        if (this.reconciliationType === 'charge') {
          BillingNativeUtils.cancelConfirmCharges(chooseRows)
          this.billDetailHp.recalculateBilling()
          this.refreshRowData(chooseRows)
        } else {
          BillingNativeUtils.cancelConfirmJobs(chooseRows)
          this.refreshRowData(chooseRows)
        }
      }).catch(() => {
        // return Promise.reject('已取消确认')
      })
    },
    // 批量确认
    batchConfirmBillingEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToConfirm'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_ACSWASRATBTSWEAC'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(async() => {
        if (this.reconciliationType === 'charge') {
          BillingNativeUtils.confirmCharges(chooseRows)
          this.billDetailHp.recalculateBilling()
          this.billDetailHp.refreshRowData(chooseRows)
        } else {
          BillingNativeUtils.confirmJobs(chooseRows)
          this.billDetailHp.recalculateBilling()
          await this.billDetailHp.refreshBilling()
          this.billDetailHp.refreshRowData(chooseRows)
        }
      }).catch(() => {
      })
    },
    // 调整账单日期时间
    updateBillingDateEvent() {
      if (!this.billingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectedBillingDate'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToModifyBillingDate'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        updateBillingDate({ uuid: this.billing.uuid, inputDate: this.billingDate, location: this.location }).then(res => {
          this.showBillDateModifyDialog = false
          this.billing = res.data
          this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        })
      }).catch(() => {
        // return Promise.reject('已取消确认')
      })
    },
    // 拆分账单费用
    splitBillChargesEvent() {
      const billing = this.billing
      if (!billing) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      if (billing.billingGroupUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SoaCreatedAlready'))
        return
      }
      if (billing.state > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillConfirmed'))
        return
      }
      if (this.reconciliationType === 'charge') { // 按费用拆分
        const chooseRows = getGridSelected(this.gridOptions)
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.PleaseSelectSplitCharge'))
          return
        }
        if (chooseRows.length !== 1) {
          this.$message.warning(this.$t('CargoMsg.OnlySelectOneChargeToSplit'))
          return
        }
        const charge = chooseRows[0]
        const canSplit = this.checkChargeForSplit(charge)
        if (!canSplit) {
          this.$message.warning(this.$t('CargoMsg.ChargeHasInvoicedOrWriteOff'))
          return
        }
        if (this.hmToFinanceApi) {
          if (charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
            this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
            return
          }
        }
        this.spiltCharge = charge
        this.showChargeSplitByChargeDialog = true
      } else if (this.reconciliationType === 'job') { // 按业务进行拆分
        const charges = this.getAllCharges()
        const exceptKeys = this.getExceptCharges(charges)
        if (!exceptKeys || exceptKeys.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoChargeForSplit'))
          return
        }
        this.exceptKeys = exceptKeys
        this.showChargeSplitByJobDialog = true
      }
    },
    // 按业务-费用拆分回调函数
    chargeSplitByJobCallBackEvent(charge) {
      this.showChargeSplitByJobDialog = false
      if (charge) {
        const canSplit = this.checkChargeForSplit(charge)
        if (!canSplit) {
          this.$message.warning(this.$t('CargoMsg.ChargeHasInvoicedOrWriteOff'))
          return
        }
        this.spiltCharge = charge
        this.showChargeSplitByChargeDialog = true
      }
    },
    // 按费用-费用拆分回调函数
    chargeSplitByChargeCallBackEvent(result) {
      this.showChargeSplitByChargeDialog = false
      // 如果拆分成功，则重新加载账单详情
      if (result) {
        this.billDetailHp.queryBillingDetail()
      }
    },
    // 按业务-费用拆分时获取可以拆分的费用
    getExceptCharges(sourceCharges) {
      const keys = []
      const charges = []
      if (sourceCharges && sourceCharges.length > 0) {
        for (let j = 0; j < sourceCharges.length; j++) {
          const charge = sourceCharges[j]
          if (this.checkChargeForSplit(charge)) {
            keys.push(charge['uuid'])
            if (keys.indexOf(charge['uuid']) >= 0) {
              charges.push(charge)
            }
          }
        }
      }
      return charges
    },
    // 校验费用是否可拆分
    checkChargeForSplit(charge) {
      let isOk = true
      if (charge['chargeInvoiceAmount'] && Number(charge['chargeInvoiceAmount']) > 0) {
        isOk = false
      }
      if (charge['chargeVerifiedAmount'] && Number(charge['chargeVerifiedAmount']) > 0) {
        isOk = false
      }
      return isOk
    },
    // 列编辑修改事件
    async onCellChange(params) {
      if (params.field === 'chargeBillingAmount') { // 按费用-对账金额
        const charge = params.data
        if (!charge) return
        const billingAmount = params.value // 输入的对账金额
        const amount = charge['chargeAmount'] // 原费用金额
        if (!billingAmount || isNaN(billingAmount)) {
          charge['chargeDiffAmount'] = amount
          charge['chargeBillingAmount'] = 0.00
          return
        }
        const chargeAmount = Math.abs(amount) // 取绝对值后的费用金额
        const billingAmountNew = Math.abs(billingAmount) // 取绝对值后的对账金额
        if (this.diffChargeByBillingAmountPattern === 1) {
          if ((chargeAmount < billingAmountNew) || (amount > 0 && billingAmount < 0) || (amount < 0 && billingAmount > 0)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TRAYEINR'))
            charge['chargeBillingAmount'] = 0.00
            return
          } else {
            if (amount > 0) {
              charge['chargeDiffAmount'] = NumberUtils.roundHalfUp(amount - billingAmount)
            } else {
              charge['chargeDiffAmount'] = NumberUtils.roundHalfUp(-(chargeAmount - billingAmountNew))
            }
            charge['dirty'] = true
          }
        } else {
          charge['chargeDiffAmount'] = NumberUtils.roundHalfUp(amount - billingAmount)
          charge['dirty'] = true
        }
        charge['chargeBillingAmount'] = Number(NumberUtils.roundHalfUp(billingAmount))
        await this.billDetailHp.refreshBilling()
      } else if (params.field === 'chargeConfirmRemarks') { // 按费用-费用确认备注
        const charge = params.data
        if (!charge) return
        charge['dirty'] = true
        charge['chargeConfirmRemarks'] = params.value
      } else if (params.field === 'chargeConfirmState') { // 按费用-费用确认状态
        const charge = params.data
        if (!charge) return
        charge['dirty'] = true
        if (charge['chargeConfirmState'] === 1) {
          charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
          charge['chargeConfirmUser'] = this.$store.getters.userId
          charge['chargeBillingAmount'] = charge['chargeAmount']
          charge['chargeDiffAmount'] = 0.00
        } else {
          charge['chargeConfirmDate'] = null
          charge['chargeConfirmUser'] = 0
          charge['chargeBillingAmount'] = 0.00
          charge['chargeDiffAmount'] = charge['chargeAmount']
        }
      } else if (params.field === 'jobBillingAmount') { // 按业务-对账金额
        const job = params.data
        if (!job) return
        const billingAmount = params.value // 输入的对账金额
        if (!billingAmount || isNaN(billingAmount)) {
          job['jobBillingAmount'] = 0.00
          job['jobDifferenceAmount'] = job['jobChargeAmountTotal']
          return
        }
        job['jobBillingAmount'] = Number(NumberUtils.roundHalfUp(billingAmount))
        BillingNativeUtils.shareJobBillingAmount(job)
        job['jobDifferenceAmount'] = await BillingNativeUtils.sumChargeDiffAmount(job)
        const charges = job['charges']
        if (charges) {
          for (let i = 0; i < charges.length; i++) {
            const charge = charges[i]
            charge['dirty'] = true
          }
        }
      } else if (params.field === 'jobConfirmState') { // 按业务-确认状态
        const job = params.data
        if (!job) return
        const value = params.value
        job['jobConfirmState'] = value
        job['dirty'] = true
        if (job['jobConfirmState'] === 1) {
          job['jobBillingAmount'] = job['jobChargeAmountTotal']
          job['jobDifferenceAmount'] = 0.00
        } else {
          job['jobBillingAmount'] = 0.00
          job['jobDifferenceAmount'] = job['jobChargeAmountTotal']
        }
        const charges = job['charges']
        if (charges) {
          for (let i = 0; i < charges.length; i++) {
            const charge = charges[i]
            if (job['chargeConfirmState'] === 1) {
              charge['chargeConfirmDate'] = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
              charge['chargeConfirmUser'] = this.$store.getters.userId
              charge['chargeBillingAmount'] = charge['chargeAmount']
            } else {
              charge['chargeConfirmDate'] = null
              charge['chargeConfirmUser'] = 0
              if (charge['chargeConfirmState'] === 1 && (charge['chargeDifferentState'] === 0 || charge['chargeDifferentState'] === 3)) {
                charge['chargeBillingAmount'] = 0
              }
            }
            charge['chargeConfirmState'] = job['jobConfirmState']
            charge['dirty'] = true
          }
        }
      }
      this.billDetailHp.refreshRowData([params.data])
    },
    // 开票/收票触发事件
    async makeInvoiceEvent() {
      // 校验账单是否符合开票要求
      await cache.load(cacheName.CONFIG)
      const invoiceBillingState = cache.config.get('InvoiceBillingState')
      if (invoiceBillingState) {
        const invoiceBillingStateArray = invoiceBillingState.split(',')
        if (invoiceBillingStateArray) {
          let ok = false
          const billing = this.billing
          for (const stateStr of invoiceBillingStateArray) {
            const state = parseInt(stateStr)
            if (state === 12 && billing.review === 1) {
              ok = true
            } else if (state === 13 && billing.review === 0) {
              ok = true
            } else if (state === billing['state'] || (state === BillingConstants.BILLING_NORMAL.code && !billing.confirmed) || (state === BillingConstants.BILLING_VERIFIED.code && billing.confirmed)) {
              ok = true
            }
          }
          if (!ok) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SDNMBR'))
            return false
          }
        }
      }
      if (this.billing.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.makeInvoiceProperties.isAr = this.billing.ar
      this.makeInvoiceProperties.isHedge = false
      this.makeInvoiceProperties.selectedEntities = [this.billing]
      this.makeInvoiceProperties.isSkipInvoiceFrom = false
      this.makeInvoiceProperties.keys = [this.billing.uuid]
      this.makeInvoiceProperties.step = 'step1'
      await this.$refs.invoice.makeInvoice({ ...this.makeInvoiceProperties })
    },
    // 加入费用
    addBillChargeEvent() {
      this.billDetailHp.addBillChargeEvent()
    },
    // 加入费用回调函数
    addChargeCallBackEvent(charges) {
      this.billDetailHp.addChargeCallBackEvent(charges)
    },
    // 移除费用/删除全部
    removeBillChargeEvent() {
      this.billDetailHp.removeBillChargeEvent()
    },
    // 查看/移除明细
    removePartBillChargeEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length !== 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BusinessNotSelected'))
        return
      }
      const job = chooseRows[0]
      let partCharges = []
      if (job['charges'] && job['charges'].length > 0) {
        partCharges = lodash.cloneDeep(job['charges'])
      }
      this.partCharges = partCharges // 此处采用复制方式，作用为弹窗重新打开时为原始数据
      this.showRemovePartBillChargeDialog = true
    },
    // 移除明细回调函数
    removePartBillChargeCallBackEvent(removeItems) {
      this.billDetailHp.removePartBillChargeCallBackEvent(removeItems)
    },
    // 计算账单金额
    calculateAmount() {
      this.billDetailHp.calculateAmount()
    },
    // 账单币种发生改变
    currencyChangeEvent(currency) {
      this.billDetailHp.currencyChangeEvent(currency)
    },
    // 打印
    printEvent() {
      const billing = this.billing
      const params = {}
      params.BILLING_UUID = billing.uuid
      params.fileAliasName = billing.billingNo
      if (billing.billingType === BillingConstants.BILLING_TYPE_INTERNAL.code) {
        params.CONFIRM_BILL_ID = billing.uuid
        params.CONFIRM_BILL_UUID = billing.uuid
        // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
        params.billingNo = billing.billingNo
        params.classNameType = SystemConstants.ACT
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'INTERNALBILLING'
        this.templateSelectorDialog.visible = true
      } else {
        params.BILLINGNO = billing.billingNo
        params.classNameType = SystemConstants.ACT
        this.templateSelectorDialog.data = params
        this.templateSelectorDialog.category = 'BILLING'
        this.templateSelectorDialog.visible = true
        this.prePrintCallback = this.prePrint
      }
    },
    async prePrint(printEvent) {
      const billing = this.billing
      if (!billing.billingNo) {
        if (billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) {
          if (!billing.overseaInvoiceDate) {
            billing.overseaInvoiceDate = ColumnUtils.dateTimeLabelFunc(new Date())
          }
        }
        billing.isPrint = true
        return setBillingsNo([billing]).then(() => {
          this.$emit('cancel')
          return this.doPrint(billing, printEvent)
        })
      } else {
        return this.doPrint(billing, printEvent)
      }
    },
    doPrint(billing, printEvent) {
      if (StimulSoftUtil.isOpenStiReport(printEvent.template)) {
        return this.$refs.cargoTemplateSelectorDialog.printFileV2(printEvent)
      } else {
        const printType = printEvent.parameter.printType
        printEvent.parameter.fileAliasName = billing.billingNo
        if (printType === PrintTemplateManager.EMAIL) {
          return this.$refs.cargoTemplateSelectorDialog.sendEmailTriggerEventHandler(printEvent)
        } else if (printType === PrintTemplateManager.FAX) {
          return PrintTemplateManager.fax(printEvent.template, PrintTemplateManager.FORMAT_PDF, printEvent.parameter)
        } else {
          return PrintTemplateManager.print(printEvent.template, printEvent.documentType, printEvent.format, printEvent.parameter, printEvent.action === 'print')
        }
      }
    },
    // 费用冲突回调事件
    conflictChargeCallBackEvent(result) {
      this.billDetailHp.conflictChargeCallBackEvent(result)
    },
    // 申请付款
    async doBillPayment() {
      if (this.billing.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      const charges = await ClearingUtils.createBillPaymentByBilling([this.billing], -1)
      if (charges && charges.length > 0) {
        this.showBillPaymentDialog = true
        this.$refs.billPayment.initBillPayment(charges)
      }
    },
    // 付款申请关闭按钮回调事件
    cancelBillPayment() {
      this.showBillPaymentDialog = false
    },
    // 获取所有费用
    getAllCharges() {
      let charges = []
      // 判断是按业务编辑还是按费用编辑
      const rowData = this.rowData
      if (this.reconciliationType === 'charge') {
        charges = rowData
      } else {
        for (let i = 0; i < rowData.length; i++) {
          const job = rowData[i]
          const jobCharges = job['charges']
          if (jobCharges && jobCharges.length > 0) {
            charges = charges.concat(jobCharges)
          }
        }
      }
      return charges
    },
    // 行数据是否可编辑
    isRowEdit(column) {
      if (!column) return false
      const data = column.data
      if (data['entity'] === 'job') {
        if (data.hasOwnProperty('charges')) {
          const charges = data['charges']
          for (let i = 0; i < charges.length; i++) {
            const charge = charges[i]
            if (charge['chargeDifferentState'] === 1 || charge['chargeDifferentState'] === 2 || charge['chargeVerifiedAmount'] !== 0) {
              return false
            }
          }
        }
      }
      if (data.hasOwnProperty('chargeVerifiedAmount')) {
        if (column.dataField === 'chargeConfirmRemarks') {
          return ((data.chargeDifferentState === 0 || data.chargeDifferentState === 3))
        }
        return data.chargeConfirmState === 0 && data.chargeVerifiedAmount === 0 && (data.chargeDifferentState === 0 || data.chargeDifferentState === 3)
      }
      return (data['jobConfirmState'] === 0 && this.checkJobItemDiff(data))
    },
    // 是否确认列可编辑
    checkConfirmable(column) {
      if (!column) return false
      let result = true
      const data = column.data
      if (data['entity'] === 'charge') {
        const differentState = parseFloat(data['chargeDifferentState'])
        result = differentState === 0 || differentState === 3
      } else if (data['entity'] === 'job') {
        if (data.hasOwnProperty('charges')) {
          const charges = data['charges']
          for (let i = 0; i < charges.length; i++) {
            const charge = charges[i]
            if (charge['chargeDifferentState'] === 1 || charge['chargeDifferentState'] === 2 || charge['chargeVerifiedAmount'] !== 0) {
              result = false
              break
            }
          }
        }
      }
      return result
    },
    // 按业务对账是否可输入对账金额
    checkJobItemDiff(data) {
      if (data.hasOwnProperty('charges')) {
        const charges = data['charges']
        for (let i = 0; i < charges.length; i++) {
          {
            const c = charges[i]
            if (c['chargeDifferentState'] === 1 && (c['chargeDifferentState'] === 1 || c['chargeDifferentState'] === 2 || c['chargeVerifiedAmount'] !== 0)) {
              return false
            }
          }
        }
      }
      return true
    },
    fetchDataByPage() {
      if (this.reconciliationType === 'job') {
        this.billDetailHp.queryJobOfBilling()
      } else if (this.reconciliationType === 'charge') {
        this.billDetailHp.queryChargeOfBilling()
      }
    },
    // 列表checkBox选中变更事件
    selectionChange() {
      this.billDetailHp.filterChange()
    },
    // 销账
    writeoffHandler() {
      if (this.billing.branchId !== this.$store.getters.currentOfficeId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return
      }
      this.properties.selectedEntities = []
      const selectedEntitie = { 'uuid': this.billing.uuid, 'accountId': this.billing.accountId, 'billingNo': this.billing.billingNo, 'currency': this.billing.currency, 'amount': this.billing.amount, 'state': this.billing.state, 'ar': this.billing.ar, 'billingType': this.billing.billingType, 'jobEtd': '' } // billing
      this.properties.selectedEntities.push(selectedEntitie)
      if (!ClearingUtils.isSameAccount(this.properties.selectedEntities)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlingPartyInconsistent'))
        return
      }
      this.properties.writeoffBillingState = String(cache.config.get('WriteoffBillingState'))
      const writeOffBillingState = []
      this.properties.writeoffBillingState.split(',').forEach(function(value) {
        writeOffBillingState.push(Number(value))
      })
      if (writeOffBillingState && this.properties.selectedEntities) {
        for (const billing of this.properties.selectedEntities) {
          let ok = false
          for (const state of writeOffBillingState) {
            if (state === 12 && billing.review === 1) {
              ok = true
            } else if (state === 13 && billing.review === 0) {
              ok = true
            } else if (state === billing.state || (state === BillingConstants.BILLING_NORMAL.code && !billing.confirmed) || (state === BillingConstants.BILLING_VERIFIED.code && billing.confirmed)) {
              ok = true
            }
          }
          if (!ok) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SDNMBR'))
            return false
          }
        }
      }
      this.initEntities()
    },
    async initEntities() {
      console.log('initEntities')
      if (this.properties.selectedEntities.length === 0) {
        return
      }
      this.properties.isExt = Number(cache.config.get('ext')) === 1
      this.properties.writeoffByDifferentAccount = Number(cache.config.get('WriteoffByDifferentAccount')) === 1
      this.properties.writeoffCheckBillpaymentDone = Number(cache.config.get('WriteoffCheckBillpaymentDone')) === 1
      this.properties.mustUseActualAmountWriteoff = Number(cache.config.get('MustUseActualAmountWriteoff')) === 1
      this.properties.isHQWriteoffConfirm = Number(cache.config.get('isHQWriteoffConfirm')) === 1
      this.properties.isWriteoffCurrencyByInvoice = Number(cache.config.get('isWriteoffCurrencyByInvoice')) === 1
      this.properties.payAfterPayApply = Number(cache.config.get('PayAfterPayApply'))
      //
      this.properties.selectedEntitiesOrigin = this.properties.selectedEntities
      this.properties.isAr = this.properties.selectedEntities[0].ar
      this.properties.isEntitiesAr = this.properties.isAr
      this.properties.isOversea = false
      if (this.properties.selectedEntities[0].billingType === BillingConstants.BILLING_TYPE_OVERSEA.code) this.properties.defaultCurrency = 'USD'
      this.properties.writeOffMode = 3 // 账单
      this.properties.entities = []
      const keys = []
      for (const item of this.properties.selectedEntities) {
        keys.push(item.uuid)
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys, 'classType': 'billing', 'isOversea': this.properties.isOversea, 'officeId': this.$store.getters.currentOfficeId }
      console.log('keys', requestBody)
      this.loading = getLoading()
      await getNotWriteoffCharges(requestBody).then(res => {
        console.log('getNotWriteoffCharges', res)
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AllSelectedBillsWrittenOff'))
        return
      }
      this.properties.selectedEntities[0].jobEtd = this.properties.entities[0].businessDate
      this.properties.accountId = this.properties.entities[0].accountId
      // 按账单销账：未核销
      if (this.properties.writeOffMode === 3) {
        const billingUuids = []
        for (const charge of this.properties.entities) {
          if (billingUuids.indexOf(charge.billingUuid) === -1) {
            billingUuids.push(charge.billingUuid)
          }
        }
        const selectedEntitiesNew = []
        for (const item of this.properties.selectedEntities) {
          if (billingUuids.indexOf(item.uuid) !== -1) {
            selectedEntitiesNew.push(item)
          }
        }
        this.properties.selectedEntities = selectedEntitiesNew
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.currencys = []
      for (const charge of this.properties.allEntities) {
        if (this.properties.currencys.indexOf(charge.currency) === -1) {
          this.properties.currencys.push(charge.currency)
        }
      }
      //
      if (this.checking) {
        this.writeOffDialog.visible = true
      }
    },
    checking() {
      if (this.properties.payAfterPayApply === 1 || this.properties.payAfterPayApply === 2 || this.properties.payAfterPayApply === 3) {
        if (this.properties.payAfterPayApply === 2) {
          const allAr = this.checkAllReceivable(this.properties.selectedEntities)
          const writeOffMode = this.properties.isHedge ? this.properties.writeOffModeHedge : this.properties.writeOffMode
          if (allAr && [2, 3, 4].includes(writeOffMode)) {
            return true
          }
        }
        for (const charge of this.properties.entities) {
          if (this.properties.payAfterPayApply === 3) {
            if (!charge.isReceivable && (charge.billPaymentUuid && charge.billPaymentState < 3)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputFail2'))
              return false
            }
          } else {
            if (!charge.isReceivable && (StrUtils.isEmpty(charge.billPaymentUuid) || charge.billPaymentState < 3)) {
              this.$message.warning(this.$t('CargoMsg.Cargo_WriteOffInputError'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAllReceivable(rows) {
      for (const row of rows) {
        if (!row.ar) {
          return false
        }
      }
      return true
    },
    toSearchTemplate(value) {
      console.log('toSearchTemplate', value)
      // 需要根据value装配this.templateSelectorDialog中相关内容(done)
      if (value) {
        // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_DETAIL", {"JOB_UUID":job.key}, FlexGlobals.topLevelApplication as DisplayObject);
        this.templateSelectorDialog.cxt = {} // Job.queryJobLink 没有迁移过来
        this.templateSelectorDialog.data.JOB_UUID = value
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    // 触发按费用拆分账单
    async splitBillChangeEvent(splitBill) {
      this.splitBillButton = splitBill
      this.nowPage = 0
      await this.onShow(splitBill)
    },
    // 显示拆分账单详细
    splitOnshow() {
      const splitCurrencyList = { ...this.splitCurrencyList }
      const splitBillData = this.splitBillData
      const currency = splitCurrencyList[this.nowPage]
      // 根据账单币种取计算好的账单数据
      this.billing = splitBillData[currency]
      if (this.reconciliationType === 'job') {
        this.rowData = this.billing.createJobs
      } else if (this.reconciliationType === 'charge') {
        // 列表使用账单中记录费用
        this.rowData = this.billing.createCharges
      }
      this.totalAmountToCurrency.dataProvider = this.billing.createCharges
      this.totalAmountToCurrency.labelText = this.billDetailHp.getRPLabel(this.billing.createCharges)
      this.billDetailHp.refreshBilling()
    },
    // 上一张
    theLastPageHandler() {
      if (this.nowPage > 0) {
        this.nowPage = this.nowPage - 1
      }
      this.splitOnshow()
    },
    // 下一张
    theNextPageHandler() {
      // 小于最大页数
      if (this.nowPage < this.splitCurrencyList.length - 1) {
        this.nowPage = this.nowPage + 1
      }
      this.splitOnshow()
    }
  }
}
</script>

<style scoped>

</style>
